import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "filter-search",
  tabindex: "-1",
  "aria-labelledby": "filterSearchlLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "visually-hidden",
  "aria-live": "assertive"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "header-title d-lg-none" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "d-flex align-items-start" }
const _hoisted_10 = {
  class: "nav flex-column nav-pills",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/ico-calendar-F9DD63.svg",
  alt: "",
  class: "img-fluid"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/arrow-back-white.svg",
  alt: "",
  class: "icon-back img-fluid"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/ico-location-F9DD63.svg",
  alt: "",
  class: "img-fluid"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/arrow-back-white.svg",
  alt: "",
  class: "icon-back img-fluid"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/ico-content-F9DD63.svg",
  alt: "",
  class: "img-fluid"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/arrow-back-white.svg",
  alt: "",
  class: "icon-back img-fluid"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/ico-writer-F9DD63.svg",
  alt: "",
  class: "img-fluid"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/arrow-back-white.svg",
  alt: "",
  class: "icon-back img-fluid"
}, null, -1)
const _hoisted_19 = {
  class: "tab-content",
  id: "v-pills-tabContent"
}
const _hoisted_20 = { class: "column" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { for: "time-radio-1" }
const _hoisted_23 = {
  key: 0,
  class: "column"
}
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { for: "time-radio-2" }
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = {
  class: "tab-pane",
  id: "v-pills-2",
  role: "tabpanel",
  "aria-labelledby": "v-pills-2-tab"
}
const _hoisted_28 = { class: "column" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { for: "location-radio-1" }
const _hoisted_31 = {
  key: 0,
  class: "column"
}
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { for: "location-radio-2" }
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = {
  class: "tab-pane",
  id: "v-pills-3",
  role: "tabpanel",
  "aria-labelledby": "v-pills-3-tab"
}
const _hoisted_36 = { class: "column" }
const _hoisted_37 = ["aria-label"]
const _hoisted_38 = { class: "list-tag list list-unstyled" }
const _hoisted_39 = {
  class: "tab-pane",
  id: "v-pills-4",
  role: "tabpanel",
  "aria-labelledby": "v-pills-4-tab"
}
const _hoisted_40 = { class: "column" }
const _hoisted_41 = ["aria-label"]
const _hoisted_42 = { class: "list-writer list list-unstyled d-flex" }
const _hoisted_43 = { class: "modal-footer" }

import { ref, onMounted, watch, computed } from 'vue'
import { useFilterPageStore } from '@/stores/filterPageStore'
import StorySearchInput from './StorySearchInput/StorySearchInput.vue'
import StoryCheckboxInput from './StoryCheckboxInput/StoryCheckboxInput.vue'
import StoryRangeSlider from './StoryRangeSlider/StoryRangeSlider.vue'
import { TAG_TYPE } from '@/models/FilterPageTypes'
import { useRouter } from 'vue-router'
import { WINDOW_WIDTH } from '@/models/WidthTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryCollectionsSearchModal',
  setup(__props) {

const selectedPane = ref<string>('init')
const searchModalClose = ref<HTMLButtonElement | undefined>(undefined)
const filterPageStore = useFilterPageStore()
const router = useRouter()

const storytellerTagQuery = ref<string>('')
const contentTagQuery = ref<string>('')
const minYear = ref<number>(1930)
const maxYear = ref<number>(new Date().getFullYear() + 1)
const yearsRange = ref<number[]>([minYear.value, maxYear.value])
const selectedlocationTags = ref<string[]>([])
const selectedTimeTags = ref<string[]>([])
const selectedContentTags = ref<string[]>([])
const selectedStorytellerTags = ref<string[]>([])
const locationType = ref<string>('')
const locationQuery = ref<string>('')
const timeType = ref<string>('')
const locationTabSrText = ref<string>('')

const tagsCoordinationObject = {
    locationTags: selectedlocationTags,
    timeTags: selectedTimeTags,
}

const isMobile = computed(() => {
    return window.innerWidth < WINDOW_WIDTH.lg
})

const direction = computed(() => document.dir);

const storytellerTags = computed(() => {
    if (storytellerTagQuery.value.trim()) {
        return filterPageStore.storytellerTags.filter((tag) => tag.Name.toLowerCase().includes(storytellerTagQuery.value.toLowerCase()))
    }
    return filterPageStore.storytellerTags
})

const contentTags = computed(() => {
    if (contentTagQuery.value.trim()) {
        return filterPageStore.contentTags.filter((tag) => tag.Name.toLowerCase().includes(contentTagQuery.value.toLowerCase()))
    }
    return filterPageStore.contentTags
})

const filterTitle = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Title') ?? '')
const activeFilterTitle = computed(() => (selectedPane.value.length ? selectedPane.value : filterTitle.value))

const saveFiltersButton = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.SaveFiltersButton') ?? '')
const clearFiltersButton = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.ClearButton') ?? '')

const dateTabName = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Date.TabName') ?? '')
const dateRangeCheckbox = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Date.DateRangeCheckbox') ?? '')
const dateTagCheckbox = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Date.TagCheckbox') ?? '')

const locationTabName = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Location.TabName') ?? '')
const locationQueryCheckbox = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Location.QueryCheckbox') ?? '')
const locationQueryPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Location.QueryPlaceholder') ?? '')
const locationTagCheckbox = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Location.TagCheckbox') ?? '')
const locationTabDescrForSr = computed(() => filterPageStore.getLocalization('Accessability.Filter.LocationTabSrText') ?? '')

const contentTabName = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Content.TabName') ?? '')
const contentQueryPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Content.QueryPlaceholder') ?? '')

const storytellerTabName = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Storyteller.TabName') ?? '')
const storytellerQueryPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.Storyteller.QueryPlaceholder') ?? '')
const modalClose = computed(() => filterPageStore.getLocalization('Accessability.Modal.Close') ?? '')
const ariaLabelSearch = computed(() => filterPageStore.getLocalization("Accessability.Search.Description") ?? '')
const ariaLabelSearchButton = computed(() => filterPageStore.getLocalization('Accessability.Search.SearchButton') ?? '')
const sliderDateRange = computed(() => filterPageStore.getLocalization("Accessability.Slider.DateRange") ?? '')

const dateTabTagsAriaLabel = computed(() => filterPageStore.getLocalization("Accessability.Filter.Category")?.replace("#TABNAME#", dateTabName.value) ?? "")
const locationTabTagsAriaLabel = computed(() => filterPageStore.getLocalization("Accessability.Filter.Category")?.replace("#TABNAME#", locationTabName.value) ?? "")
const contentTabTagsAriaLabel = computed(() => filterPageStore.getLocalization("Accessability.Filter.Category")?.replace("#TABNAME#", contentTabName.value) ?? "")
const authorTabTagsAriaLabel = computed(() => filterPageStore.getLocalization("Accessability.Filter.Category")?.replace("#TABNAME#", storytellerTabName.value) ?? "")

//const altCalendar = computed(() => filterPageStore.getLocalization('Accessability.Images.Calendar'))
//const altLocation = computed(() => filterPageStore.getLocalization('Accessability.Images.Location'))
//const altContent = computed(() => filterPageStore.getLocalization('Accessability.Images.Content'))
//const altStoryteller = computed(() => filterPageStore.getLocalization('Accessability.Images.Storyteller'))

const timeFilters = computed(() => {
    if (timeType.value === '1') {
        return yearsRange.value.join(' - ')
    }
    const keys = [...selectedTimeTags.value]
    return (
        filterPageStore.timeTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const locationFilters = computed(() => {
    if (locationType.value === '1') {
        return locationQuery.value
    }
    const keys = [...selectedlocationTags.value]
    return (
        filterPageStore.locationTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const contentFilters = computed(() => {
    const keys = [...selectedContentTags.value]
    return (
        filterPageStore.contentTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const storytellerFilters = computed(() => {
    const keys = [...selectedStorytellerTags.value]
    return (
        filterPageStore.storytellerTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})
async function submitSearchForm() {
    filterPageStore.storySearchModel.storytellerTags = [...selectedStorytellerTags.value]
    filterPageStore.storySearchModel.locationTags = [...selectedlocationTags.value]
    filterPageStore.storySearchModel.contentTags = [...selectedContentTags.value]
    filterPageStore.storySearchModel.timeTags = [...selectedTimeTags.value]
    filterPageStore.storySearchModel.yearsRange = [...yearsRange.value]
    filterPageStore.storySearchModel.timeType = timeType.value
    filterPageStore.storySearchModel.locationType = locationType.value
    filterPageStore.storySearchModel.locationQuery = locationQuery.value

    searchModalClose.value?.click()
}

function loadPersistentState() {
    selectedStorytellerTags.value = [...filterPageStore.storySearchModel.storytellerTags]
    selectedlocationTags.value = [...filterPageStore.storySearchModel.locationTags]
    selectedContentTags.value = [...filterPageStore.storySearchModel.contentTags]
    selectedTimeTags.value = [...filterPageStore.storySearchModel.timeTags]
    yearsRange.value = [...filterPageStore.storySearchModel.yearsRange]
    timeType.value = filterPageStore.storySearchModel.timeType
    locationType.value = filterPageStore.storySearchModel.locationType
    locationQuery.value = filterPageStore.storySearchModel.locationQuery
}

function clearFilters() {
    selectedStorytellerTags.value = []
    selectedlocationTags.value = []
    selectedContentTags.value = []
    selectedTimeTags.value = []
    yearsRange.value = []
    timeType.value = '1'
    locationType.value = '1'
    locationQuery.value = '' 
}

async function onClearFilters() {
    clearFilters()

    await submitSearchForm()

    router.replace({ query: undefined })
}

function onSelectPane(paneName: string) {
    selectedPane.value = paneName

    if (paneName === locationTabName.value) {
        locationTabSrText.value = locationTabDescrForSr.value 
    }
}

    function onCloseFilterPane() {
        selectedPane.value = filterTitle.value
        locationTabSrText.value = ''
        document.querySelectorAll('#filter-search .nav-link')?.forEach((i) => {
            i?.classList?.remove('active')
            i?.setAttribute('tabindex', '0')
        })
}

function clearOnSelect(value: string) {
    tagsCoordinationObject[value].value = []
}

const removeEmptyParams = (obj: object) => Object.entries(obj).reduce((a, [k, v]) => (v && v.length > 0 ? ((a[k] = v), a) : a), {})
/// Gets strings array from object by property name
const getStringsArray = (obj: any, propName: string) => {
    if (obj[propName] && obj[propName].length > 0) {
        if (obj[propName][0].length > 1) {
            return obj[propName]
        }

        return [obj[propName]]
    }

    return []
}

watch(
    filterPageStore.storySearchModel,
    async () => {
        const queryParams = removeEmptyParams({ ...router.currentRoute.value.query, ...filterPageStore.storySearchModel })

        router.push({
            query: {
                ...queryParams,
            },
        })
        filterPageStore.stories = []
        await filterPageStore.searchStories()

        if (!filterPageStore.isAnyFiltersPushed()) {
            clearFilters()
        }
    },
    { deep: true }
)

onMounted(() => {
    // @ts-ignore
    $('#filter-search').on('show.bs.modal, hide.bs.modal', () => {
        loadPersistentState()
    })
    // @ts-ignore
    $('#filter-search').on('hidden.bs.modal', () => {
        //TODO: to prevent history modification by modal
        const fullPath = router.currentRoute.value.fullPath
        window.history.replaceState({}, '', fullPath)
    })

    filterPageStore.stories = []
    const filters: any = { ...router.currentRoute.value.query }

    filterPageStore.storySearchModel.timeType = filters?.timeType ?? '1'
    filterPageStore.storySearchModel.timeTags = getStringsArray(filters, 'timeTags')
    filterPageStore.storySearchModel.yearsRange = filters?.yearsRange ?? []

    filterPageStore.storySearchModel.locationType = filters?.locationType ?? '1'
    filterPageStore.storySearchModel.locationTags = getStringsArray(filters, 'locationTags')
    filterPageStore.storySearchModel.locationQuery = filters?.locationQuery ?? ''

    filterPageStore.storySearchModel.contentTags = getStringsArray(filters, 'contentTags')

    filterPageStore.storySearchModel.storytellerTags = getStringsArray(filters, 'storytellerTags')

    loadPersistentState()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(locationTabSrText.value), 1),
          _withDirectives(_createElementVNode("button", {
            class: "close d-lg-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onCloseFilterPane()))
          }, null, 512), [
            [_vShow, selectedPane.value !== _unref(filterTitle) && selectedPane.value !== 'init']
          ]),
          _createElementVNode("button", {
            ref_key: "searchModalClose",
            ref: searchModalClose,
            type: "button",
            class: "btn-close d-none d-lg-block",
            "data-bs-dismiss": "modal",
            "aria-label": _unref(modalClose)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, _toDisplayString(selectedPane.value !== 'init' ? _unref(activeFilterTitle) : _unref(filterTitle)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link", _unref(isMobile) ? '' : 'active']),
                id: "v-pills-1-tab",
                "data-bs-toggle": "pill",
                "data-bs-target": "#v-pills-1",
                type: "button",
                role: "tab",
                "aria-controls": "v-pills-1",
                "aria-selected": "true",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelectPane(_unref(dateTabName))))
              }, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_unref(dateTabName)) + " ", 1),
                (_unref(timeFilters).length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (timeType.value === '1' ? (yearsRange.value = []) : (selectedTimeTags.value = []))),
                      class: "filter-option"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_unref(timeFilters)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_12
              ], 2),
              _createElementVNode("button", {
                class: "nav-link",
                id: "v-pills-2-tab",
                "data-bs-toggle": "pill",
                "data-bs-target": "#v-pills-2",
                type: "button",
                role: "tab",
                "aria-controls": "v-pills-2",
                "aria-selected": "false",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onSelectPane(_unref(locationTabName))))
              }, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_unref(locationTabName)) + " ", 1),
                (_unref(locationFilters).length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (locationType.value === '1' ? (locationQuery.value = '') : (selectedlocationTags.value = []))),
                      class: "filter-option"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_unref(locationFilters)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_14
              ]),
              _createElementVNode("button", {
                class: "nav-link",
                id: "v-pills-3-tab",
                "data-bs-toggle": "pill",
                "data-bs-target": "#v-pills-3",
                type: "button",
                role: "tab",
                "aria-controls": "v-pills-3",
                "aria-selected": "false",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (onSelectPane(_unref(contentTabName))))
              }, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_unref(contentTabName)) + " ", 1),
                (_unref(contentFilters).length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedContentTags.value = [])),
                      class: "filter-option"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_unref(contentFilters)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_16
              ]),
              _createElementVNode("button", {
                class: "nav-link",
                id: "v-pills-4-tab",
                "data-bs-toggle": "pill",
                "data-bs-target": "#v-pills-4",
                type: "button",
                role: "tab",
                "aria-controls": "v-pills-4",
                "aria-selected": "false",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (onSelectPane(_unref(storytellerTabName))))
              }, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_unref(storytellerTabName)) + " ", 1),
                (_unref(storytellerFilters).length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (selectedStorytellerTags.value = [])),
                      class: "filter-option"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_unref(storytellerFilters)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_18
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", _unref(isMobile) ? '' : 'active show']),
                id: "v-pills-1",
                role: "tabpanel",
                "aria-labelledby": "v-pills-1-tab"
              }, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((timeType).value = $event)),
                        id: "time-radio-1",
                        name: "timeType",
                        value: "1",
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (clearOnSelect('timeTags')))
                      }, null, 544), [
                        [_vModelRadio, timeType.value]
                      ]),
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(dateRangeCheckbox)), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["", [timeType.value === '1' ? 'active' : '']])
                    }, [
                      _createVNode(StoryRangeSlider, {
                        modelValue: yearsRange.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((yearsRange).value = $event)),
                        min: minYear.value,
                        max: maxYear.value,
                        sliderDateRange: _unref(sliderDateRange),
                        disabled: timeType.value !== '1',
                        dir: _unref(direction)
                      }, null, 8, ["modelValue", "min", "max", "sliderDateRange", "disabled", "dir"])
                    ], 2)
                  ]),
                  (_unref(filterPageStore).timeTags.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((timeType).value = $event)),
                            id: "time-radio-2",
                            name: "timeType",
                            value: "2"
                          }, null, 512), [
                            [_vModelRadio, timeType.value]
                          ]),
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(dateTagCheckbox)), 1)
                        ]),
                        _createElementVNode("div", {
                          role: "group",
                          "aria-label": _unref(dateTabTagsAriaLabel)
                        }, [
                          _createElementVNode("ul", {
                            class: _normalizeClass(["list-tag list list-unstyled", [timeType.value === _unref(TAG_TYPE).CONFIRMED_TAG ? 'active' : '']])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterPageStore).timeTags, (tag) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "list-tag-item",
                                key: `timeTag-${tag.Key}`,
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (timeType.value = '2'))
                              }, [
                                _createVNode(StoryCheckboxInput, {
                                  label: tag.Name,
                                  id: `timeTag-${tag.Key}`,
                                  name: `timeTag-${tag.Key}`,
                                  inputValue: tag.Key,
                                  modelValue: selectedTimeTags.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedTimeTags).value = $event)),
                                  disabled: timeType.value === _unref(TAG_TYPE).CONFIRMED_TAG ? false : true
                                }, null, 8, ["label", "id", "name", "inputValue", "modelValue", "disabled"])
                              ]))
                            }), 128))
                          ], 2)
                        ], 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((locationType).value = $event)),
                        id: "location-radio-1",
                        name: "locationType",
                        value: "1",
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (clearOnSelect('locationTags')))
                      }, null, 544), [
                        [_vModelRadio, locationType.value]
                      ]),
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(locationQueryCheckbox)), 1)
                    ]),
                    _createVNode(StorySearchInput, {
                      modelValue: locationQuery.value,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((locationQuery).value = $event)),
                      placeholder: _unref(locationQueryPlaceholder),
                      "input-aria-label": _unref(ariaLabelSearch),
                      "button-aria-label": _unref(ariaLabelSearchButton),
                      class: _normalizeClass([locationType.value === '1' ? 'active' : ''])
                    }, null, 8, ["modelValue", "placeholder", "input-aria-label", "button-aria-label", "class"])
                  ]),
                  (_unref(filterPageStore).locationTags.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((locationType).value = $event)),
                            id: "location-radio-2",
                            name: "locationType",
                            value: "2"
                          }, null, 512), [
                            [_vModelRadio, locationType.value]
                          ]),
                          _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(locationTagCheckbox)), 1)
                        ]),
                        _createElementVNode("div", {
                          role: "group",
                          "aria-label": _unref(locationTabTagsAriaLabel)
                        }, [
                          _createElementVNode("ul", {
                            class: _normalizeClass(["list-tag list list-unstyled", [locationType.value === _unref(TAG_TYPE).CONFIRMED_TAG ? 'active' : '']])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterPageStore).locationTags, (tag) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "list-tag-item",
                                key: `locationTag-${tag.Key}`,
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (locationType.value = '2'))
                              }, [
                                _createVNode(StoryCheckboxInput, {
                                  label: tag.Name,
                                  id: `locationTag-${tag.Key}`,
                                  name: `locationTag-${tag.Key}`,
                                  inputValue: tag.Key,
                                  modelValue: selectedlocationTags.value,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedlocationTags).value = $event)),
                                  disabled: locationType.value === _unref(TAG_TYPE).CONFIRMED_TAG ? false : true
                                }, null, 8, ["label", "id", "name", "inputValue", "modelValue", "disabled"])
                              ]))
                            }), 128))
                          ], 2)
                        ], 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(StorySearchInput, {
                      modelValue: contentTagQuery.value,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((contentTagQuery).value = $event)),
                      "input-aria-label": _unref(ariaLabelSearch),
                      "button-aria-label": _unref(ariaLabelSearchButton),
                      placeholder: _unref(contentQueryPlaceholder)
                    }, null, 8, ["modelValue", "input-aria-label", "button-aria-label", "placeholder"])
                  ]),
                  _createElementVNode("div", {
                    class: "column",
                    role: "group",
                    "aria-label": _unref(contentTabTagsAriaLabel)
                  }, [
                    _createElementVNode("ul", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentTags), (tag) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-tag-item",
                          key: `contentTag-${tag.Key}`
                        }, [
                          _createVNode(StoryCheckboxInput, {
                            label: tag.Name,
                            id: `contentTag-${tag.Key}`,
                            name: `contentTag-${tag.Key}`,
                            inputValue: tag.Key,
                            modelValue: selectedContentTags.value,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((selectedContentTags).value = $event))
                          }, null, 8, ["label", "id", "name", "inputValue", "modelValue"])
                        ]))
                      }), 128))
                    ])
                  ], 8, _hoisted_37)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(StorySearchInput, {
                      modelValue: storytellerTagQuery.value,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((storytellerTagQuery).value = $event)),
                      "input-aria-label": _unref(ariaLabelSearch),
                      "button-aria-label": _unref(ariaLabelSearchButton),
                      placeholder: _unref(storytellerQueryPlaceholder)
                    }, null, 8, ["modelValue", "input-aria-label", "button-aria-label", "placeholder"])
                  ]),
                  _createElementVNode("div", {
                    class: "column",
                    role: "group",
                    "aria-label": _unref(authorTabTagsAriaLabel)
                  }, [
                    _createElementVNode("ul", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storytellerTags), (tag) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-writer-item",
                          key: `storytellerTag-${tag.Key}`
                        }, [
                          _createVNode(StoryCheckboxInput, {
                            label: tag.Name,
                            id: `storytellerTag-${tag.Key}`,
                            icon: tag.ImageUrl,
                            name: `storytellerTag-${tag.Key}`,
                            inputValue: tag.Key,
                            modelValue: selectedStorytellerTags.value,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((selectedStorytellerTags).value = $event))
                          }, null, 8, ["label", "id", "icon", "name", "inputValue", "modelValue"])
                        ]))
                      }), 128))
                    ])
                  ], 8, _hoisted_41)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("button", {
            type: "button",
            class: "clear",
            onClick: onClearFilters
          }, _toDisplayString(_unref(clearFiltersButton)), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: submitSearchForm
          }, _toDisplayString(_unref(saveFiltersButton)), 1)
        ])
      ])
    ])
  ]))
}
}

})